<template>
  <div class="d-flex flex-column fill-height transparent" style="width: 100%">
    <!--    <p class="chat-room-title">-->
    <!--      {{ $t("participant.chat.title") }}-->
    <!--    </p>-->
    <!--    <div v-if="users && users.length === 0">-->
    <!--      {{ $t("participant.chat.empty") }}-->
    <!--    </div>-->
    <!--    <v-list>-->
    <!--      <v-list-item class="pb-1" v-bind:key="index" v-for="(user, index) in users">-->
    <!--        <v-avatar :color="user.color">-->
    <!--          <span style="color: white">{{ user.initials }}</span>-->
    <!--        </v-avatar>-->
    <!--        <span class="pl-2">-->
    <!--          {{ user.username }}-->
    <!--        </span>-->
    <!--      </v-list-item>-->
    <!--    </v-list>-->

    <ParticipantHeader
      class="flex-grow-0"
      :drawer="drawer"
      @click="$emit('click')"
      :icon="zoomEnabled ? 'mdi-video-account' : 'mdi-forum-outline'"
    ></ParticipantHeader>

    <ZoomRoom
      v-if="zoomEnabled"
      :meetingNumber="$store.state.activityTeam.zoomMeetingNumber"
      :meetingCode="$store.state.activityTeam.zoomMeetingCode"
      :userName="$store.state.participantUsername"
      :hostMode="!!$route.query.teamCaptain"
    />

    <v-list class="mb-auto flex-grow-1 pa-2" dense id="participant-chat-log" style="overflow: auto" v-if="!zoomEnabled">
      <v-list-item
        :key="item.id"
        v-bind:class="{
          primary: $store.state.participantId === item.participantId,
          'lighten-5': $store.state.participantId === item.participantId && !isDarkTheme,
          'darken-5': $store.state.participantId === item.participantId && isDarkTheme,
        }"
        v-for="item in $store.state.textChatMessages"
      >
        <v-list-item-avatar :color="item.color" size="36">
          <span>{{ item.initials }}</span>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="font-weight-medium" v-text="item.username"></v-list-item-title>
          <v-list-item-subtitle
            class="font-weight-regular"
            v-text="item.message"
            style="white-space: normal"
          ></v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-form
      @submit.prevent="sendTextMessage"
      class="align-start px-2 flex-grow-1"
      ref="messageForm"
      v-if="!zoomEnabled"
    >
      <v-text-field
        :label="$t('participant.chat.sayHello')"
        maxlength="255"
        v-model="message"
        prepend-icon="mdi-forum-outline"
        style="width: calc(100% - 52px)"
      >
        <template v-slot:append-outer>
          <v-btn color="primary" fab tile type="submit" x-small elevation="0" :disabled="!message">
            <v-icon>mdi-send</v-icon>
          </v-btn>
        </template>
      </v-text-field>
    </v-form>
  </div>
</template>

<script>
import axios from "axios";
import ParticipantHeader from "./participant.header";
import ZoomRoom from "./participant.zoom";

export default {
  name: "ParticipantChatBar",
  components: { ParticipantHeader, ZoomRoom },
  props: {
    drawer: null,
  },
  mounted() {
    if (!this.zoomEnabled) this.scrollChatToBottom();
  },
  computed: {
    zoomEnabled() {
      return !!(this.$store.state.activityTeam && this.$store.state.activityTeam.zoomMeetingNumber);
    },
    users() {
      return this.$store.state.participants;
    },
    isDarkTheme() {
      return this.$store.state.event.brandingTheme === "dark";
    },
  },
  data() {
    return {
      message: null,
    };
  },
  methods: {
    scrollChatToBottom() {
      const element = document.getElementById("participant-chat-log");
      element.scrollTop = element.scrollHeight - element.clientHeight;
    },
    sendTextMessage() {
      if (this.message && this.message.trim()) {
        const data = {
          message: this.message,
          participantId: this.$store.state.participantId,
        };
        axios.post(`/event/activities/session/${this.$store.state.sessionId}/textMessage`, data);
        this.message = "";
      }
    },
  },
  watch: {
    drawer(value) {
      console.log(value);
      if (this.zoomEnabled && this.$vuetify.breakpoint.xs) {
        this.$store.commit("VIDEO_MUTED", value);
      }
    },
  }
};
</script>

<style scoped lang="scss">
#participant-chat-log {
  min-height: 120px;
  background-image: url("/assets/chat.svg");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 280px auto;
}
</style>
